import React, { useEffect, useRef, useState } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import { ArrowLeft, PlusCircleFill } from "react-bootstrap-icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import convertTimestamp from "../../utils/helpers/convertTimeStamp";
import "./survey.scss";
import formatDate from "../../utils/helpers/formatDate";
import profileIcon from "../../assets/default-profile.png";
import { Modal, Pagination } from "react-bootstrap";

interface Options {
  quiz_id: number;
  option: string;
  correct_answer: 0 | 1;
}

interface QuizData {
  id: number;
  created: string;
  survey_id: number;
  question: string;
  quiz_type: string;
  quizOptionData: Options[];
  correct_answer: string;
  status: number;
}

interface UserInfo {
  name: string;
  profilePic: string;
  submittedOption: string;
}

const SurveyDetails = () => {
  const navigate = useNavigate();
  const cmpMounted = useRef(false);
  // const {id} = useParams()
  const location = useLocation();
  const { id } = location.state;
  const [quizData, setQuizData] = useState<any>([]);
  const [folderName, setFolderName] = useState("");
  // const location = useLocation();
  // const [folderName, setFolderName] = useState<string>("")
  const dispatch = useAppDispatch();
  const [answers, setAnswers] = useState<UserInfo[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string>("");

  useEffect(() => {
    if (cmpMounted.current === true) return;
    if (id) {
      fetchSurveyQuizDetails();
      cmpMounted.current = true;
    }
  }, [id]);

  const fetchSurveyQuizDetails = async () => {
    try {
      dispatch(showLoader("Loading data..."));
      console.log(location.state.id);
      const response = await postDetails(APIList.GET_QUIZ_DATA_BY_SURVEY_ID, {
        survey_id: Number(id),
      });
      console.log(response);
      setFolderName(response.data.name);
      if (response.data.quizData) {
        const result = response.data.quizData.map((quiz: any) => ({
          name: response.data.name,
          ...quiz,
          created: new Date(quiz.created).toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
        }));
        setQuizData(result);
      } else {
        setQuizData([]);
      }

      // console.log(result)
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleSurveyQuizDelete = async (item: QuizData) => {
    try {
      const response = await postDetails(APIList.DELETE_SURVEY_QUIZ, {
        id: item.id,
      });
      console.log(response);
      if (response.status === "Failed") {
        dispatch(showToast(`Cannot delete survey quiz`));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }
      dispatch(showToast("Survey Quiz Deleted Succesfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
      fetchSurveyQuizDetails();
    } catch (error) {
      console.log(error);
    }
  };

  const redirectToSurveyPage = () => {
    navigate("/survey");
  };

  const handleAnswerCount = async (
    item: any,
    type: "correct" | "wrong" | "descriptive"
  ) => {
    try {
      const response = await postDetails(APIList.GET_ALL_USER_SURVEY_DATA, {
        quiz_id: item.id,
        type: type,
      });
      console.log(response);
      if (response.statusCode === 200 && response.data) {
        const formattedUserInfo: UserInfo[] = response.data.userInfo.map(
          (user: any) => ({
            name: user.name,
            profilePic: user.profile || profileIcon,
            submittedOption: user.submittedOption || "N/A",
          })
        );

        setAnswers(formattedUserInfo);
        setCurrentPage(1);
        setShowModal(true);
        console.log(formattedUserInfo);
      } else {
        console.error("Failed to fetch answers");
      }
    } catch (error) {
      console.error("Error fetching answers:", error);
    }
  };

  const columns: TableColumn[] = [
    {
      key: "created",
      label: "Created",
      //  sortable: true
    },
    {
      key: "name",
      label: "Survey Name",
      // sortable: true,
      dataType: "string",
    },

    {
      key: "question",
      label: "Question",
      //   render: (item) => {
      //   return (
      //     <p
      //     //  className="fixed-container"
      //      >{item.question}</p>
      //   )
      // },
      dataType: "string",
      sortable: true,
    },
    {
      key: "quiz_type",
      label: "Quiz Type",
      // sortable: true,
      dataType: "string",
    },
    {
      key: "correct_answer",
      label: "Quiz Correct Answer",
      sortable: true,
      render: (item) => {
        if (item.quiz_type === "Textual Option") {
          return item.correct_answer;
        } else {
          return "N/A";
        }
      },
      // dataType:"string"
    },
    {
      key: "descriptiveCount",
      label: "Descriptive Count",
      sortable: true,
      render: (item) => {
        const count = item.descriptiveCount;

        return (
          <div
            className={`d-flex justify-content-center text-primary ${
              count > 0
                ? "cursor-pointer text-decoration-underline"
                : "text-muted"
            }`}
            // onClick={() => count > 0 && handleAnswerCount(item, "descriptive")}
          >
            {count > 0 ? count : "N/A"}
          </div>
        );
      },
    },
    {
      key: "correctAnswerCount",
      label: "Correct Answers",
      sortable: true,
      render: (item) => {
        if (item.quiz_type === "Descriptive Option") {
          return (
            <div className="d-flex justify-content-center text-muted">N/A</div>
          );
        } else {
          return (
            <div
              className="text-primary cursor-pointer text-decoration-underline"
              onClick={() => handleAnswerCount(item, "correct")}
            >
              {" "}
              {item.correctAnswerCount || 0}{" "}
            </div>
          );
        }
      },
    },
    {
      key: "wrongAnswerCount",
      label: "Wrong Answers",
      sortable: true,
      render: (item) => {
        if (item.quiz_type === "Descriptive Option") {
          return (
            <div className="d-flex justify-content-center text-muted">N/A</div>
          );
        } else {
          return (
            <div
              className="text-primary cursor-pointer text-decoration-underline"
              onClick={() => handleAnswerCount(item, "wrong")}
            >
              {" "}
              {item.wrongAnswerCount || 0}{" "}
            </div>
          );
        }
      },
    },
  ];

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const ITEMS_PER_PAGE = 8;
  const PAGINATION_DISPLAY_LIMIT = 5;

  const totalItems = answers.length;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const paginatedAnswers = answers.slice(startIndex, endIndex);

  const buttons = [
    {
      label: "Back to Survey List",
      theme: "danger",
      icon: <ArrowLeft />,
      onClick: redirectToSurveyPage,
    },
    {
      label: "Add Survey Quiz",
      theme: "danger",
      icon: <PlusCircleFill />,
      onClick: () => {
        navigate("/survey/addQuiz");
      },
    },
  ];

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage("");
    setAnswers([]);
  };

  const getPaginationItems = () => {
    const paginationItems = [];
    const startPage = Math.max(
      1,
      currentPage - Math.floor(PAGINATION_DISPLAY_LIMIT / 2)
    );
    const endPage = Math.min(
      totalPages,
      startPage + PAGINATION_DISPLAY_LIMIT - 1
    );

    for (let i = startPage; i <= endPage; i++) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    return paginationItems;
  };

  return (
    <LayoutContainer title="Survey Quiz">
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Survey Quiz {folderName && `- ${folderName}`}
        </h2>
      </div>
      <PageHeader buttons={buttons} />
      <div className="mx-2">
        {quizData.length !== 0 ? (
          <CommonTable<QuizData>
            data={quizData}
            columns={columns}
            onDelete={handleSurveyQuizDelete}
            pagination={true}
            rowsPerPage={10}
            actions={{
              view: false,
              edit: false,
              delete: true,
              checkbox: false,
              status: false,
              showModal: false,
            }}
          />
        ) : (
          <p>No Quiz Posted</p>
        )}
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Data for {folderName}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "400px",
            overflowY: "auto",
            padding: "1.5rem",
          }}
        >
          {paginatedAnswers.length > 0 ? (
            paginatedAnswers.map((user, index) => (
              <div key={index} className="d-flex align-items-center mb-3">
                <div className="me-3">
                  <img
                    src={user.profilePic || profileIcon}
                    // alt={user.name}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                    }}
                  />
                </div>
                <div>
                  <p className="mb-0">
                    <strong>{user.name}</strong>
                  </p>
                  <p className="mb-0">
                    Submitted Option: {user.submittedOption || "N/A"}{" "}
                  </p>
                  {/* <p className="mb-0">
      Submitted Option:{" "}
      {isImageUrl(user.submittedOption) ? (
        <img
          src={user.submittedOption}
          alt="Submitted Option"
          style={{ maxWidth: "70px", maxHeight: "70px" }} // Adjust styles as needed
        />
      ) : (
        user.submittedOption || "N/A"
      )}
    </p> */}
                </div>
              </div>
            ))
          ) : (
            <p>No data available for answers.</p>
          )}
        </Modal.Body>
        {totalPages > 1 && (
          <Modal.Footer>
            <Pagination>
              {currentPage !== 1 && (
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                />
              )}
              {getPaginationItems()}
              {currentPage !== totalPages && (
                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                />
              )}
            </Pagination>
          </Modal.Footer>
        )}
        {totalPages === 1 && (
          <Modal.Footer>
            <button className="btn-danger" onClick={handleCloseModal}>
              Close
            </button>
          </Modal.Footer>
        )}
      </Modal>
    </LayoutContainer>
  );
};

export default SurveyDetails;
